<template>
  <RegisterForm
    v-if="!loading && training?.id"
    :trainingTypes="trainingTypes"
    @refresh="refresh()"
  />
</template>

<script setup>
import RegisterForm from "@/components/Trainings/SingleSchulungen/Form/Register.vue";
import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();

const loading = computed(() => store.getters.getBTrainingLoading);
const training = computed(() => store.getters.getBTraining);
const trainingTypes = computed(() => store.getters.getBTrainingTypes);

const loadPage = () => {
  store.dispatch("loadBTrainingPage", route.params.id);
};

const refresh = async () => {
  await store.dispatch("loadBTrainingPage", route.params.id);
  await store.dispatch("me");
};

onMounted(loadPage);

watch(
  () => route.params.id,
  (id, previousId) => {
    if (id && id !== previousId) {
      loadPage();
    }
  },
);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
